import axios from 'axios';

export const publicIP = () => {
	return axios.get('https://api.ipify.org/?format=json')
		.then(response => {
			return response.data;
		})
		.catch((err) => {
		});
};